import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const paperTradingLogoSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.1871 33.8506L13.1828 33.4792L12.5551 37.75C12.5551 37.75 18.8739 38.8018 25.36 38.5558C32.4319 38.2876 37.5371 36.2857 37.5371 36.2857L38.5833 31.8695L36.8676 35.6254C36.8676 35.6254 32.1809 37.3177 25.36 37.4827C18.5391 37.6478 14.0197 36.781 14.0197 36.781L14.1871 33.8506Z"
            fill="currentColor"/>
        <path
            d="M9.41666 29.1455L12.5551 23.2846L13.8523 24.6879L11.8437 28.6502C11.8437 28.6502 16.1539 32.2409 21.6357 33.7268C27.1175 35.2127 33.8547 34.3459 33.8547 34.3459L38.4996 27.577L34.5661 35.2127C34.5661 35.2127 29.168 36.6242 21.3428 34.8C13.5176 32.9756 9.41666 29.1455 9.41666 29.1455Z"
            fill="currentColor"/>
        <path
            d="M19.0412 9.41669L12.0948 18.3318C12.0948 18.3318 13.8523 23.5735 20.0874 28.2375C26.3224 32.9014 31.9298 32.6125 31.9298 32.6125L37.579 22.8306C37.579 22.8306 32.3064 22.4179 27.0338 18.7032C21.7612 14.9886 19.0412 9.41669 19.0412 9.41669Z"
            fill="currentColor"/>
    </svg>
)

const PaperTradingLogo: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {paperTradingLogoSvg}
    </SvgIcon>
)

export default PaperTradingLogo